import $ from 'jquery';

$(document).ready(function() {
  $('.subs-payment-tab').on('click', function(e) {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const paymentAttr = $this.find('.custom-radio__input').attr('data-payment');

    $('.subs-payment-tab')
      .find('.custom-radio__input')
      .attr('checked', false);

    $this.find('.custom-radio__input').attr('checked', true);

    if (paymentAttr === 'payment-doc') {
      $('.subs-with-doc').removeClass('hide');
    } else {
      $('.subs-with-doc').addClass('hide');
    }

    if (
      $('.subs-entry__form').hasClass('electronic-subscription') &&
      paymentAttr === 'payment-online'
    ) {
      $('.subs-with-online').addClass('hide');
    } else {
      $('.subs-with-online').removeClass('hide');
    }
  });

  $('.subs__opportunities-open').on('click', e => {
    const $this = $(e.currentTarget);

    $this.closest('.subs__type').toggleClass('open');

    if ($('.subs__type').hasClass('open')) {
      $this.find('span').text('Сховати');
      $('.subs__opportunities').fadeIn('Fast');
    } else {
      $this.find('span').text('Більше');
      $('.subs__opportunities').fadeOut('Fast');
    }
  });

  if ($('body').hasClass('subs-page')) {
    $(window).on('scroll', e => {
      const parallax = $('.scroll-effect');
      // const parallaxSmall = $('.scroll-effect--small');

      let itemOffHeight;
      let itemHeight;
      let pointStart;
      // let coefficient;

      parallax.each(function(index, item) {
        itemOffHeight = $(item).offset().top;
        itemHeight = $(item).height();
        pointStart = $(window).scrollTop() + 720;

        if ($(window).scrollTop() > itemOffHeight - itemHeight + 40) {
          return;
        }

        if (pointStart < itemOffHeight && $(item).hasClass('active')) {
          $(item).removeClass('active');
        }

        if (pointStart > itemOffHeight && !$(item).hasClass('active')) {
          $(item).addClass('active');
        }
      });
    });
  }

  $('.subs__questions-link').on('click', e => {
    let $this = $(e.currentTarget);

    $this.closest('.subs__questions-item').toggleClass('open');

    $this.find('.subs__questions-answer').slideToggle('fast');
  });

  if ($('.subs-entry__form').hasClass('electronic-subscription')) {
    $('.electronic-subscription__mail')
      .find('.mailing__form-input')
      .attr('disabled', 'disabled')
      .val('Укрпошта');
  }

  $('.user-not-login').on('click', e => {
    let $this = $(e.currentTarget);

    $.fancybox.open({
      src: '#authorization-window',
      closeExisting: true,
      smallBtn: false,
      toolbar: false,
      touch: false
    });
  });
});
